module.exports = __webpack_public_path__ + "static/home-90e583ca0e0880bbaeeae87473d24a37.mp4";